import { useContext } from 'react';
import { List, Item } from 'elements/List';
import { Paragraph, Link } from 'elements/Text';
import { UserContext } from 'contexts/UserContext';
import routes from 'routes';

const Saves = () => {
  const { saveList } = useContext(UserContext);

  return saveList.length ? (
    <List>
      {saveList.map(save => (
        <Item key={save.id}>
          <Link to={`${routes.root}${routes.games.root}${routes.games.saves}${save.id}`}>{save.title}</Link> by {save.author}
        </Item>
      ))}
    </List>
  ) : (
    <Paragraph>
      No saves available...
    </Paragraph>
  );
}

export default Saves;
